import { render, staticRenderFns } from "./HeaderPreMatchWithReferee.vue?vue&type=template&id=64a7728a&scoped=true&"
import script from "./HeaderPreMatchWithReferee.vue?vue&type=script&lang=js&"
export * from "./HeaderPreMatchWithReferee.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPreMatchWithReferee.vue?vue&type=style&index=0&id=64a7728a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7728a",
  null
  
)

export default component.exports